import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-mig/cloud_migrate_cta.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100 cloud_mig_solution"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Migrate to Cloud with TekRevol</h2>
            <p>
              Discuss your cloud expansion strategies with TekRevol to receive
              expert consultation on deployment, migration, cost optimization,
              and scalability. Partner with our trusted cloud migration company
              to transition to a seamless, efficient, and resilient cloud
              ecosystem.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
